import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import IconBox from '../IconBox'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function ServiceDetailsPage() {
  pageTitle('Smart Contract Development');
  const params = useParams();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <PageHeading
        title='Smart Contract Development'
        bgSrc='/images/service_hero_bg.jpeg'
        pageLinkText={'Smart Contract Development'}
      />

      <Spacing lg='145' md='80' />

      {/* Introduction Section */}
      <Div className="container">
        <SectionHeading
          title='What Are Smart Contracts?'
          subtitle='Introduction to Blockchain Agreements'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <p className='cs-text_large text-center'>
          Smart contracts are self-executing digital agreements that run on blockchain networks. They automatically enforce predefined conditions without the need for intermediaries, ensuring transparency, accuracy, and trust. These contracts are integral to decentralized applications (DApps) and blockchain ecosystems, revolutionizing industries by enabling secure and efficient automation.
        </p>
        <Spacing lg='20' md='15' />
        <p className='cs-text_large text-center'>
          At DAppster Studio, we bring your business to the forefront of blockchain innovation by developing custom smart contracts that are reliable, secure, and optimized for scalability.
        </p>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Smart Contract Services */}
      <Div className="container">
        <SectionHeading
          title='Our Smart Contract Development Services'
          subtitle='Tailored Blockchain Solutions'
          variant='cs-style1 text-center'
        />
        <Spacing lg='90' md='45' />
        <Div className="row">
          <Div className="mt-2 col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_1.svg'
              title='Custom Smart Contract Development'
              subtitle='Designed and coded to meet specific business requirements.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="mt-2 col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_2.svg'
              title='Smart Contract Auditing'
              subtitle='Comprehensive security checks to identify and resolve vulnerabilities.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="mt-2 col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_3.svg'
              title='Token Development'
              subtitle='Creation of tokens (ERC-20, BEP-20, etc.) for fundraising, rewards, and ecosystem utility.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="mt-2 col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_4.svg'
              title='DeFi Smart Contracts'
              subtitle='Staking, lending, and yield farming protocols for decentralized finance platforms.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="mt-2 col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_5.svg'
              title='NFT Smart Contracts'
              subtitle='Secure contracts for minting, trading, and managing non-fungible tokens (NFTs).'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="mt-2 col-lg-4">
            <IconBox
              icon='/images/icons/service_icon_6.svg'
              title='Smart Contract Optimization'
              subtitle='Enhancing performance and reducing gas fees.'
            />
            <Spacing lg='30' md='30' />
          </Div>
          <Div className="mt-2 col-lg-12">
            <IconBox
              icon='/images/icons/service_icon_7.svg'
              title='Cross-Chain Compatibility'
              subtitle='Smart contracts designed for Ethereum, Binance Smart Chain, Polygon, Solana, and more.'
            />
            <Spacing lg='30' md='30' />
          </Div>
        </Div>
      </Div>

      <Spacing lg='120' md='60' />

      {/* Industries Section */}
      <Div className="container">
        <SectionHeading
          title='Industries We Serve'
          subtitle='Smart Contract Applications Across Sectors'
          variant='cs-style1 text-center'
        />
        <Spacing lg='30' md='20' />
        <Div className="row">
          <Div className="mt-2 col-lg-4">
            <IconBox
              icon='/images/icons/money-icon.svg'
              title='Finance'
              subtitle='Decentralized finance (DeFi) applications for lending, staking, and asset management.'
            />
          </Div>
          <Div className="mt-2 col-lg-4">
            <IconBox
              icon='/images/icons/game-icon.svg'
              title='Gaming'
              subtitle='Blockchain-based games with NFT integration and secure asset transactions.'
            />
          </Div>
          <Div className="mt-2 col-lg-4">
            <IconBox
              icon='/images/icons/truck-icon.svg'
              title='Supply Chain'
              subtitle='Smart contracts for transparent, traceable logistics and inventory management.'
            />
          </Div>
        </Div>
        <Div className="row mt-lg-5 mx-auto">
          <Div className="mt-2 col-lg-6">
            <IconBox
              icon='/images/icons/house-icon.svg'
              title='Real Estate'
              subtitle='Tokenized property platforms and automated agreements for seamless transactions.'
            />
          </Div>
          <Div className="mt-2 col-lg-6">
            <IconBox
              icon='/images/icons/healthcare-icon.svg'
              title='Healthcare'
              subtitle='Secure patient data sharing and automated insurance claims.'
            />
          </Div>
        </Div>
      </Div>

      <Spacing lg='150' md='80' />
    </>
  )
}
